import React, { useContext } from 'react';
import { Redirect } from 'react-router-dom';
import { signOut } from 'aws-amplify/auth';
import WorkOrderContext from '../context/WorkOrderContext';
import StoreContext from '../context/StoreContext';

const Logout = () => {
  const { clearWorkOrders } = useContext(WorkOrderContext);
  const { resetStore } = useContext(StoreContext);
  localStorage.clear();
  clearWorkOrders();
  resetStore();
  signOut();
  
  return <Redirect to={{ pathname: '/' }} />;
};
export default Logout;
